/**
 * Страница гайда регистрации для tablet PWA
 * В стиле Samsung OneUI
 */
import { useDeviceStore } from '../store/deviceStore'
import './RegistrationGuidePage.css'

export function RegistrationGuidePage() {
  const deviceStore = useDeviceStore()

  return (
    <div className="registration-guide oneui-style">
      {/* Logo and Title */}
      <div className="guide-header">
        <div className="logo-section">
          <div className="logo-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="#0078D7" />
              <path d="M2 17L12 22L22 17V11L12 16L2 11V17Z" fill="#0078D7" opacity="0.6" />
            </svg>
          </div>
          <h1 className="app-title">Recvisit</h1>
          <p className="app-subtitle">Система контроля доступа</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="guide-content">
        <h2 className="welcome-title">Добро пожаловать!</h2>
        <p className="welcome-description">
          Для начала работы с этим планшетом необходимо пройти регистрацию
        </p>

        {/* Steps */}
        <ol className="steps-list">
          <li className="step-item">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3 className="step-title">Обратитесь к администратору</h3>
              <p className="step-description">
                Свяжитесь с администратором вашей системы контроля доступа
              </p>
            </div>
          </li>

          <li className="step-item">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3 className="step-title">Регистрация устройства</h3>
              <p className="step-description">
                Администратор должен зарегистрировать это устройство в системе и создать для него учетные данные
              </p>
            </div>
          </li>

          <li className="step-item">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3 className="step-title">Перейдите по ссылке</h3>
              <p className="step-description">
                Используйте ссылку регистрации, предоставленную администратором, чтобы активировать планшет
              </p>
            </div>
          </li>
        </ol>

        {/* Access Denied Notice */}
        <div className="access-denied">
          <div className="access-denied-icon">🔒</div>
          <p className="access-denied-text">Доступ без регистрации запрещен</p>
        </div>

        {/* Device Info */}
        <div className="device-info">
          <h4 className="device-info-title">Идентификатор устройства:</h4>
          <div className="device-id-box">
            <code className="device-id">{deviceStore.deviceId || 'Генерация...'}</code>
          </div>
          <p className="device-info-hint">
            Сообщите этот идентификатор администратору
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="guide-footer">
        <p className="footer-text">© 2025 Recvisit. Все права защищены.</p>
      </div>
    </div>
  )
}
